"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderDirections = exports.createCommentSuccesMessages = exports.LockStatus = exports.userRoles = exports.reportResultType = exports.formats = exports.RecentlyViewedTypes = exports.ApiBatchLimits = exports.reportsType = exports.clipboardKeys = exports.highRiskMessage = exports.errorMessages = exports.errorCodes = exports.commentsPage = exports.DomainAccess = exports.CookieExpiration = exports.StatusColors = void 0;
var StatusColors;
(function (StatusColors) {
    StatusColors["success"] = "#38b079";
    StatusColors["error"] = "#df1e44";
    StatusColors["info"] = "#7356cc";
    StatusColors["warning"] = "#f2db00";
    StatusColors["gray"] = "#7f8994";
    StatusColors["blue"] = "#297ec1";
    StatusColors["orange"] = "#ffa700";
    StatusColors["purple"] = "#7356cc";
})(StatusColors = exports.StatusColors || (exports.StatusColors = {}));
var CookieExpiration;
(function (CookieExpiration) {
    CookieExpiration[CookieExpiration["days"] = 365] = "days";
})(CookieExpiration = exports.CookieExpiration || (exports.CookieExpiration = {}));
var DomainAccess;
(function (DomainAccess) {
    DomainAccess["Finpay"] = "FINPAY";
    DomainAccess["Client"] = "CLIENT";
})(DomainAccess = exports.DomainAccess || (exports.DomainAccess = {}));
var commentsPage;
(function (commentsPage) {
    commentsPage["clients"] = "clients";
    commentsPage["patients"] = "patients";
})(commentsPage = exports.commentsPage || (exports.commentsPage = {}));
var errorCodes;
(function (errorCodes) {
    errorCodes["invalidWorkflow"] = "INVALID_WORKFLOW";
    errorCodes["duplicateUserName"] = "USERNAME_ALREADY_EXISTS";
    errorCodes["duplicateRule"] = "DUPLICATE_RULE";
    errorCodes["externalServiceError"] = "EXTERNAL_SERVICE_ERROR";
})(errorCodes = exports.errorCodes || (exports.errorCodes = {}));
var errorMessages;
(function (errorMessages) {
    errorMessages["duplicateUser"] = "Client primary contact user already exists, please try again";
    errorMessages["duplicateRule"] = "Duplicate Entry found, please change values and try again";
})(errorMessages = exports.errorMessages || (exports.errorMessages = {}));
var highRiskMessage;
(function (highRiskMessage) {
    highRiskMessage["highRisk"] = "FinPay has completed the financial clearance curriculum as outlined in the Financial Clearance Policy Builder and based on those financial clearance rules the patient has failed financial clearance, resulting in a \"HIGH RISK\" status.\u00A0 Please review the information below to determine if an exception should be made for this patient";
})(highRiskMessage = exports.highRiskMessage || (exports.highRiskMessage = {}));
var clipboardKeys;
(function (clipboardKeys) {
    clipboardKeys["downPmtAmt"] = "Down Payment";
    clipboardKeys["insurancePlanName"] = "Insurance Plan";
    clipboardKeys["copayAmt"] = "Copay";
    clipboardKeys["coinsuranceAmt"] = "CoInsurance";
    clipboardKeys["deductibleAmt"] = "Deductible";
    clipboardKeys["oopmaxAmt"] = "OOPM";
    clipboardKeys["remainingOOPMaxAmt"] = "Remaining OOP Max Amount";
    clipboardKeys["insuranceCompanyName"] = "Insurance Provider";
})(clipboardKeys = exports.clipboardKeys || (exports.clipboardKeys = {}));
var reportsType;
(function (reportsType) {
    reportsType[reportsType["AllInstanceofCare"] = "All Instance of Care"] = "AllInstanceofCare";
    reportsType[reportsType["PatientFinancialClearance"] = "Patient Financial Clearance"] = "PatientFinancialClearance";
    reportsType[reportsType["Transactions"] = "Transactions Report"] = "Transactions";
    reportsType[reportsType["SettlementSummary"] = "Settlement Reports"] = "SettlementSummary";
    reportsType[reportsType["SettlementDetail"] = "Settlement Detail"] = "SettlementDetail";
})(reportsType = exports.reportsType || (exports.reportsType = {}));
var ApiBatchLimits;
(function (ApiBatchLimits) {
    ApiBatchLimits[ApiBatchLimits["patientRecords"] = 2500] = "patientRecords";
    ApiBatchLimits[ApiBatchLimits["users"] = 2500] = "users";
    ApiBatchLimits[ApiBatchLimits["reports"] = 2500] = "reports";
})(ApiBatchLimits = exports.ApiBatchLimits || (exports.ApiBatchLimits = {}));
var RecentlyViewedTypes;
(function (RecentlyViewedTypes) {
    RecentlyViewedTypes["clients"] = "clients";
    RecentlyViewedTypes["convertedPatients"] = "convertedPatients";
    RecentlyViewedTypes["preConvertedPatients"] = "preConvertedPatients";
})(RecentlyViewedTypes = exports.RecentlyViewedTypes || (exports.RecentlyViewedTypes = {}));
var formats;
(function (formats) {
    formats["usd"] = "USD";
    formats["percentage"] = "Percentage";
})(formats = exports.formats || (exports.formats = {}));
var reportResultType;
(function (reportResultType) {
    reportResultType["timeStamp"] = "Timestamp";
    reportResultType["bigDecimal"] = "BigDecimal";
    reportResultType["string"] = "String";
    reportResultType["integer"] = "Integer";
    reportResultType["boolean"] = "Boolean";
})(reportResultType = exports.reportResultType || (exports.reportResultType = {}));
var userRoles;
(function (userRoles) {
    userRoles["accountHolder"] = "Account Holder";
    userRoles["clientOwner"] = "Client Owner";
    userRoles["finpaySuperUser"] = "Finpay Super User";
})(userRoles = exports.userRoles || (exports.userRoles = {}));
var LockStatus;
(function (LockStatus) {
    LockStatus["release"] = "RELEASE";
    LockStatus["deny"] = "DENY";
})(LockStatus = exports.LockStatus || (exports.LockStatus = {}));
var createCommentSuccesMessages;
(function (createCommentSuccesMessages) {
    createCommentSuccesMessages["comment"] = "Comment Created";
    createCommentSuccesMessages["statusChangeComment"] = "Status changed and comment created";
})(createCommentSuccesMessages = exports.createCommentSuccesMessages || (exports.createCommentSuccesMessages = {}));
var orderDirections;
(function (orderDirections) {
    orderDirections["asc"] = "asc";
    orderDirections["desc"] = "desc";
})(orderDirections = exports.orderDirections || (exports.orderDirections = {}));
